import Pagination from "../../entities/Pagination";
import {action, computed, makeObservable, observable, runInAction} from "mobx";
import CommonStore from "../../stores/CommonStore";
import { BillingPeriodService } from "../../service/BillingPeriodService";
import { AgencyService } from "../../service/AgencyService";
import ChildAgencyBillingPeriodResponse from "../../model/billingPeriod/ChildAgencyBillingPeriodResponse";

class AgencyChildBillingStore {

    public billingPeriods: ChildAgencyBillingPeriodResponse[];
    public pagination: Pagination;
    public filter?: string;
    public commonStore: CommonStore;
    public totalDue: number = 0;


    constructor(commonStore: CommonStore) {
        this.pagination = new Pagination(1, 15, 0, 0);
        this.billingPeriods = [];
        this.commonStore = commonStore;
        makeObservable(this, {
            billingPeriods: observable,
            pagination: observable,
            totalDue: observable,
            isEmpty: computed
        });
    }

    get isEmpty(): boolean {
        return this.billingPeriods.length === 0;
    }

    public setFilter(filer: string) {
        this.filter = filer;
    }

    @action
    public async getAgencyBalance(): Promise<void> {
        this.commonStore.setLoading();
        // Nota: O serviço BillingPeriodService.get deve ser adaptado no backend para retornar 
        // apenas os dados da agência logada ou um novo endpoint específico deve ser usado.
        const response = await AgencyService.getBalance();
        if (response.success) {
            runInAction(() => {
                this.totalDue = response.data?.amount ?? 0;
            })
        }
        this.commonStore.processErrors(response);
        this.commonStore.removeLoading();
    }

    @action
    public async search() {
        await this.getElements(1);
    }


    @action
    public async goToPage(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        await this.getElements(page, pageSize);
    }

    @action
    public async getElements(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        this.commonStore.setLoading();
        // Nota: O serviço BillingPeriodService.get deve ser adaptado no backend para retornar 
        // apenas os dados da agência logada ou um novo endpoint específico deve ser usado.
        const response = await BillingPeriodService.getChildAgencyBillingPeriod(page, pageSize, this.filter);
        if (response.success) {
            runInAction(() => {
                this.billingPeriods = response.data?.data || [];
                this.pagination = response.data?.pagination || this.pagination;
            })
        }
        this.commonStore.processErrors(response);
        this.commonStore.removeLoading();
    }

}

export default AgencyChildBillingStore;
